import axiosInstance from "./common/axiosInstance";
import { getFrequencyCounterUrl , baseFrequencyUrl} from "./common/apiKeys"; 
import { FrequencyCountResponse, FrequencyResponse } from "./common/types";

export const fetchFrequencyCounter = async (): Promise<number> => {
    const { data } = await axiosInstance.get<FrequencyCountResponse>(getFrequencyCounterUrl);
    return data.count;
};

export const fetchFrequencyByIndex = async (n: number): Promise<FrequencyResponse> => {
    const { data } = await axiosInstance.get<FrequencyResponse>(`${baseFrequencyUrl}/${n}`);
    return data;
};
  
export const createNewFrequency = async (): Promise<FrequencyResponse> => {
    const { data } = await axiosInstance.post<FrequencyResponse>(baseFrequencyUrl);
    return data;
};
  
export const deleteFrequencyByIndex = async (n: number): Promise<void> => {
    await axiosInstance.delete(`${baseFrequencyUrl}/${n}`);
};